module.exports = __webpack_public_path__ + "media/images/avatar/green-836da953c293db9f4cf7f5a3f0e0270d.svg";